import styled from "styled-components";

export const DashbaordMerchantChartWrapper = styled.div`
  
`;
